import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions.jsx";

export const useGenericAvatarUrl = () => {
  const genericAvatarUrl = useSelector((state) => getRawConfigOption(state, "avatar_url"));
  const getAvatarUrl = useCallback(
    (email) => {
      return genericAvatarUrl
        ? genericAvatarUrl
            .replace("--USER-EMAIL--", `${email}`)
            .replace("--USER-NAME--", `${email.split("@")[0]}`)
            .replace("--USER-ID--", `0`)
            .replace("--SIZE--", `24`)
            .replace("--UPDATED-ON--", `0`)
        : undefined;
    },
    [genericAvatarUrl]
  );

  return { getAvatarUrl };
};
